<template>
  <div class="gallery-image-card">
    <div class="thumbnail mb-0">
      <a :href="image.url" target="_blank" v-tooltip="'Open image in a new tab.'" class="gallery-image-link">
        <img :src="image.url" :alt="image.file_name" loading="lazy" class="gallery-image" />
      </a>
      <div class="caption">
        <button
          type="button"
          class="btn btn-danger mr-3"
          :disabled="deleting"
          v-tooltip="'Delete Image'"
          @click="onDeleteButtonClick"
        >
          <i class="fas fa-fw" :class="deleting ? 'fa-spinner fa-spin' : 'fa-trash'"></i>
        </button>
        <div class="gallery-image-url">
          <div class="input-group">
            <input
              type="text"
              class="form-control step-share-input"
              :id="'gallery-image-' + image.id"
              :value="image.short_url"
              readonly
            />
            <span class="input-group-btn">
              <button
                class="btn btn-default"
                type="button"
                :disabled="copied"
                :title="copied ? 'The URL has already been copied!' : 'Copy the URL to clipboard'"
                v-tooltip="copied ? 'The URL has already been copied!' : 'Copy the URL to clipboard'"
                @click="onCopyButtonClick"
              >
                <i class="fa-fw" :class="copied ? 'fas fa-clipboard' : 'far fa-copy'"></i>
              </button>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'gallery-image-card',
  props: {
    deleting: {
      type: Boolean,
      required: true,
    },
    image: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      copied: false,
    };
  },
  methods: {
    onCopyButtonClick() {
      if (window.navigator.clipboard) {
        window.navigator.clipboard.writeText(this.image.short_url).then(() => (this.copied = true));
      } else {
        document.getElementById('gallery-image-' + this.image.id).select();
        if (document.execCommand('copy')) {
          this.copied = true;
        }
      }
      setTimeout(() => (this.copied = false), 5000);
    },
    onDeleteButtonClick() {
      if (!this.deleting) {
        this.$emit('delete');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.gallery-image-card {
    position: relative;

    &::before {
        content: "";
        display: inline-block;
        width: 1px;
        height: 0;
        padding-bottom: 100%;
    }
}

.thumbnail {
    display: flex;
    flex-direction: column;
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
}

.gallery-image-link {
    display: flex;
    flex-grow: 1;
    min-height: 0;
}

.gallery-image {
    flex-grow: 1;
    object-fit: cover;
}

.caption {
    display: flex;
    flex-shrink: 0;

    & > .input-group {
        flex-grow: 1;
    }
}

.gallery-image-url {
  flex-grow: 1;
}
</style>
